import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders, HttpParams } from '@angular/common/http';
import { Observable } from 'rxjs';
import { ConfigService } from '../config-service/config.service';
import { CognitoUserPool } from 'amazon-cognito-identity-js';
import { LoginService } from '../login-service/login.service';

@Injectable({
  providedIn: 'root',
})
export class CustomerContactService {
  public config: any = null;
  constructor(
    private http: HttpClient,
    private configService: ConfigService,
    private loginService: LoginService
  ) {
    const strConfig = localStorage.getItem('config-service');
    if (strConfig !== null) this.config = JSON.parse(strConfig);
    else {
      this.configService._config_$.subscribe((x) => {
        this.config = x;
      });
    }
  }

  getCustomerDropdown(): Observable<any> {
    const token = this.loginService.getSessionToken();
    const headers = new HttpHeaders({
      'Content-Type': 'application/json',
      Authorization: `Bearer ${token}`,
    });

    return this.http.post(this.config.clientCustomerURL, {}, { headers });
  }

  getContactDropdown(customerId: string): Observable<any> {
    let params = new HttpParams();
    const token = this.loginService.getSessionToken();
    params = params.set('customer_id', customerId);

    const headers = new HttpHeaders({
      'Content-Type': 'application/json',
      Authorization: `Bearer ${token}`,
    });

    return this.http.post(
      this.config.clientAccountURL,
      {},
      { headers, params }
    );
  }

  getCognitoUserPool() {
    const poolData = {
      UserPoolId: this.config.cognitoUserPoolId,
      ClientId: this.config.cognitoAppClientId,
    };
    return new CognitoUserPool(poolData);
  }
}
